import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { Global } from 'src/app/config/config';
import { ApiResponse } from 'src/app/models/api-response';
import { Banco } from 'src/app/models/catalogos/banco';
import { Catalogos } from 'src/app/models/catalogos/catalogos';
import { Estado } from 'src/app/models/catalogos/estado';
import { Estatus } from 'src/app/models/catalogos/estatus';
import { EstatusIncidencias } from 'src/app/models/catalogos/estatus-incidencias';
import { FormasDeposito } from 'src/app/models/catalogos/formas-deposito';
import { Municipio } from 'src/app/models/catalogos/municipio';
import { TipoIncidencias } from 'src/app/models/catalogos/tipo-incidencias';
import { TiposDeposito } from 'src/app/models/catalogos/tipos-deposito';

@Injectable({
  providedIn: 'root'
})
export class CatalogosService {

  constructor(private http: HttpClient) { }

  setCatalogos(catalogos: Catalogos) {
    Object.keys(catalogos).forEach(element => {
      localStorage.setItem(element, JSON.stringify(catalogos[element]));
    })
  }

  getCatalogos() {
    return this.http.post<ApiResponse>(`${Global.URL_API}Catalogos`, {})
      .pipe(
        map(response => {
          if (response.code == 200) {
            return response.data as Catalogos
          }
          else {
            return undefined;
          }
        })
      )
  }

  getEstados(): Observable<Estado[]> {
    let estados = localStorage.getItem('Estados') ? JSON.parse(localStorage.getItem('Estados')) as Estado[] : [] as Estado[];
    return of(estados);
  }

  getMunicipios(): Observable<Municipio[]> {
    let municipios = localStorage.getItem('Municipios') ? JSON.parse(localStorage.getItem('Municipios')) as Municipio[] : [] as Municipio[];
    return of(municipios);
  }

  getEstatusCajero(): Observable<Estatus[]> {
    let estatuses = localStorage.getItem('Estatus') ? JSON.parse(localStorage.getItem('Estatus')) as Estatus[] : [] as Estatus[];
    return of(estatuses);
  }

  getArrEstatusCajero(): Estatus[] {
    let estatuses = localStorage.getItem('Estatus') ? JSON.parse(localStorage.getItem('Estatus')) as Estatus[] : [] as Estatus[];
    return estatuses
  }

  getBancos(): Observable<Banco[]> {
    let bancos = localStorage.getItem('Bancos') ? JSON.parse(localStorage.getItem('Bancos')) as Banco[] : [] as Banco[];
    return of(bancos);
  }

  getTiposDeposito(): Observable<TiposDeposito[]> {
    let tiposDeposito = localStorage.getItem('Tipo_Deposito') ? JSON.parse(localStorage.getItem('Tipo_Deposito')) as TiposDeposito[] : [] as TiposDeposito[];
    return of(tiposDeposito);
  }

  getFormasDeposito(): Observable<FormasDeposito[]> {
    let formasDeposito = localStorage.getItem('Formas_Deposito') ? JSON.parse(localStorage.getItem('Formas_Deposito')) as FormasDeposito[] : [] as FormasDeposito[];
    return of(formasDeposito);
  }

  getTipoIncidencias(): Observable<TipoIncidencias[]> {
    let tipoIncidencias = localStorage.getItem('Tipo_Incidencias') ? JSON.parse(localStorage.getItem('Tipo_Incidencias')) as TipoIncidencias[] : [] as TipoIncidencias[];
    return of(tipoIncidencias);
  }

  getEstatusIncidencias(): Observable<EstatusIncidencias[]> {
    let estatusIncidencias = localStorage.getItem('Estatus_Incidencias') ? JSON.parse(localStorage.getItem('Estatus_Incidencias')) as EstatusIncidencias[] : [] as EstatusIncidencias[];
    return of(estatusIncidencias);
  }
}
